import { T } from '@homeschooling/sdk'
import mtz from 'moment-timezone'

//import * as M from 'moment'
//import * as _ from 'lodash'

//import { parseURL } from '@stdlib/Helpers/URL'

// Source values from query string, persist them for the visit.
export class Persistence {
  private userId: number = 0
  private auth: T.JwtToken = {} as T.JwtToken
  private mockMode: number = 0 
  private env: T.Env = 'local'
  private user: T.User | boolean = false
  private students: T.Student[] = []
  private jwt: string = ''
  private tz: string = ''

  public setEnv (env: T.Env): this {
    this.env = env

    return this
  }

  public getEnv (): T.Env {
    return this.env
  }

  public setAuth (user: T.User): this {
    this.auth = user.token
    this.setUserId(Number(user.id))
    this.setStudents(user.students as T.Student[])
    this.setUser(user)
    this.setJwt(user.token.access_token)
    this.setTz()
    return this
  }

  public getAuth (): T.JwtToken {
    return this.auth
  }

  public setUser (user: T.User | boolean = false) {

       if (user !== false) {
        this.user = user
        localStorage.setItem('user', JSON.stringify(user))

        return
      }
  
      /*const sessionUser: string | boolean = this.getSearch('user', false)
console.log('session user', sessionUser)
      if (typeof sessionUser === 'string') {
        localStorage.setItem('user', sessionUser)
        this.user = JSON.parse(sessionUser)
  
        return
      }*/
  
      const hasStorage = localStorage.getItem('user') !== null

      if (!hasStorage) {
          user = {} as T.User
      } else {
        let session = localStorage.getItem('user') as string
        user = JSON.parse(session) as T.User
      }

      this.user = user
      return
  }

  public getUser () {
    return this.user
  }

  public setJwt(jwt: string | null = '') {
    
    if (jwt && jwt !== '') {
      this.jwt = jwt
      localStorage.setItem('jwt', String(jwt))

      return
    }

    /*userId = Number(this.getSearch('userId', 0))

    if (userId >= 0) {
      localStorage.setItem('userId', String(userId))
      this.userId = userId

      return
    }*/

    jwt = localStorage.getItem('jwt')

    if (jwt === undefined || jwt === null) {
        jwt = ''
    }

    this.jwt = jwt
  }

  public getJwt () {
    return this.jwt
  }
  

  public setTz(tz: string | null = '') {
    
    if (tz && tz !== '') {
      this.tz = tz
      localStorage.setItem('tz', String(tz))

      return
    }

    tz = localStorage.getItem('tz')

    if (tz === undefined || tz === null || tz.length === 0) {
        tz = mtz.tz.guess(true)
    }

    this.tz = tz
    localStorage.setItem('tz', String(tz))
    return
  }

  public getTz () {
    return this.tz ? this.tz : mtz.tz.guess(true)
  }

  public setStudents (students?: T.Student[]) {

    if (students) {
      this.students = students
      localStorage.setItem('students', JSON.stringify(students))

      return
  }

    /*const sessionStudent: string | boolean = this.getSearch('students', false)

    if (students) {
      localStorage.setItem('students', sessionStudent)
      this.students = JSON.parse(students)

      return
    }*/

    let session = localStorage.getItem('students') as string
    const hasStorage = session !== null && session?.length > 0 

    if (!hasStorage) {
        students = [] as T.Student[]
    } else {
        students = JSON.parse(session) as T.Student[]
    }

    this.students = students
    return
  }

  public getStudents () {
  return this.students ? this.students : []
  }

  public setUserId (userId: number = -1) {
    

    if (userId >= 0) {
      this.userId = userId
      localStorage.setItem('userId', String(userId))

      return
    }

    /*userId = Number(this.getSearch('userId', 0))

    if (userId >= 0) {
      localStorage.setItem('userId', String(userId))
      this.userId = userId

      return
    }*/

    userId = Number(localStorage.getItem('userId'))

    if (userId === undefined) {
        userId = 0
    }

    this.userId = userId
  }

  public getUserId () {
    return this.userId
  }

  public setMockMode () {
    let mockMode = Number(this.getSearch('mock'))

    // If mockMode is missing (or non-int) we'll use stored value.
    if (isNaN(mockMode)) {
      mockMode = Number(sessionStorage.getItem('mock'))

      if (isNaN(mockMode) || mockMode < 1) {
        mockMode = 0
      }
    } else {
      // Otherwise, we want to set it to the user specified value
      sessionStorage.setItem('mock', String(mockMode))
    }

    this.mockMode = Number(mockMode)

    if (this.getMockMode()) {
      console.info('Running in mock mode!')
    }
  }

  public setValues () {
    this.setUserId()
    this.setMockMode()
    this.setUser()
    this.setStudents()
    this.setJwt()
  }

  public getMockMode (): boolean {
    // Per request, allow this on prod
    // if (this.getEnv() === 'prod') return false

    return Number(this.mockMode) > 0 ? true : false
  }

  public async clear () {
    //console.log('clearing storage')
    //let user = this.getUserId()

    this.setUserId(0)
    this.setMockMode()
    this.setUser(false)
    this.setStudents([])
    //while(user !== undefined && user > 0) {
      //await window.localStorage.clear()
      //await window.sessionStorage.clear()

      //user = this.getUserId()
    //}

    //console.log('storage cleared', this.getUserId())

    return this
  }

  public saveSettings (settings: {}[]) {
    sessionStorage.setItem('settings', JSON.stringify(settings))
  }

  public getSavedSettings () {
    const savedSettings = sessionStorage.getItem('settings')

    if (null === savedSettings) return null

    return JSON.parse(savedSettings)
  }

  // tslint:disable no-any
  private getSearch (key: string, def: any = undefined) {
    //const { searchObject } = parseURL(location.href)

    //return _.get(searchObject, key, def)
    return false
  }
}

const persistence = new Persistence()
export default persistence